export const SHADOW_REGION_TO_GRID_AREA_MAP = {
  topLeft: 'sticky-top-left',
  topMiddle: 'sticky-top',
  topRight: 'sticky-top-right',
  middleLeft: 'sticky-left',
  inside: 'inside',
  middleRight: 'sticky-right',
  bottomLeft: 'sticky-bottom-left',
  bottomMiddle: 'sticky-bottom',
  bottomRight: 'sticky-bottom-right',
} as const;
